const ProductPageNav = function () {
    const debug = () => typeof window?.productNavScrollDebug !== 'undefined' ? window?.productNavScrollDebug : false;
    const itemSelector = 'product-page-nav__link';
    const stickySelector = 'sticky';
    const activeLinkClass = 'is-active';
    /**
     * @type {HTMLElement|Element|null}
     */
    let scrollToRulerEl = null;
    /**
     * @type {HTMLElement|Element|null}
     */
    let targetRulerEl = null;
    /**
     * @type {string}
     */
    let lastActiveId = '';
    /**
     * Element to receive sticky class
     * @type {HTMLElement|null}
     */
    let parentEl = null;
    /**
     *
     * @type {NodeList|null}
     */
    let navLinks = null;
    /**
     * An array of section elements.
     * @type {HTMLElement[]|null}
     */
    let navTargets = null;
    /**
     * Pseudo constructor
     * @private
     */
    const __construct = () => {
        navLinks = document.querySelectorAll(`.product-page-nav .${itemSelector}`);
        if (!navLinks.length)
            return;
        navTargets = Array.from(navLinks).map(x => document.querySelector(x.hash));
        if (!navTargets.length)
            return;
        parentEl = document.querySelector('.product-page-nav__section');
        if (!parentEl)
            return;
        navLinks.addEventListener('click', onClick);
        window.addEventListener('scroll', onScroll);
        onScroll(false);
    };
    const onScroll = (scrollToTarget = true) => {
        let setStickyState = determineStickyState();
        setStickyState ? setSticky() : unsetSticky();
        highlightActiveNavItem(scrollToTarget);
    };
    const determineStickyState = () => {
        let header = document.querySelector('header.header');
        let currentHeaderOffset = parentEl.querySelector('.row.expanded').distanceTop(header);
        return currentHeaderOffset <= header.offsetHeight;
    };
    const setSticky = () => {
        return parentEl.classList.add(stickySelector);
    };
    const unsetSticky = () => {
        return parentEl.classList.remove(stickySelector);
    };
    const highlightActiveNavItem = (scrollToTarget = true) => {
        if (!navTargets || !navTargets.length)
            return;
        let scrollDistanceMod = window.scrollY + (window.innerHeight / 3);
        let extraMargin = window.innerWidth < 640 ? 75 : 150;
        let activeSection = navTargets.find(x => scrollDistanceMod >= x.distanceTop() + extraMargin && scrollDistanceMod <= x.distanceTop() + x.offsetHeight);
        if (activeSection && activeSection.id !== lastActiveId) {
            /**
             * @type {Node|HTMLElement}
             */
            let navLink = Array.from(navLinks).find(x => x.hash === `#${activeSection.id}`);
            if (!navLink) {
                return;
            }
            navLinks.forEach(x => x.closest('li').classList.remove(activeLinkClass));
            navLink.closest('li').classList.add(activeLinkClass);
            lastActiveId = activeSection.id;
            if (!scrollToTarget) {
                return;
            }
            navLink.closest('ul').scroll({
                behavior: 'smooth',
                left: navLink.offsetLeft
            });
        }
    };
    /**
     * Stuff to do when submenu link is clicked.
     *
     * @param {MouseEvent} e
     */
    const onClick = e => {
        e.preventDefault();
        let clickedEl = e.target;
        let targetEl = document.querySelector(clickedEl.hash);
        if (!targetEl)
            return;
        // 1. Get the actual document-relative top position
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = targetEl.getBoundingClientRect().top;
        const totalOffsetTop = elementRect - bodyRect;
        // 2. Get the heights of your sticky elements
        const headerHeight = document.querySelector('header.header')?.offsetHeight || 0;
        // Use 44px (the sticky height) since it will be sticky once we arrive
        const productNavHeight = 44;
        // 3. Subtract the sticky "dead zone" from the total distance
        const scrollTo = totalOffsetTop - (headerHeight + productNavHeight);
        window.scroll({
            behavior: 'smooth',
            top: scrollTo,
        });
    };
    const createRulers = (targetDistance, scrollToDistance) => {
        if (!scrollToRulerEl) {
            scrollToRulerEl = document.createElement('div');
            scrollToRulerEl.id = 'ruler-scroll-to';
        }
        if (!targetRulerEl) {
            targetRulerEl = document.createElement('div');
            targetRulerEl.id = 'ruler-target';
        }
        scrollToRulerEl.style = `position: absolute; width: 100%; height: 3px; z-index: 9999; background-color: red; top: ${scrollToDistance}px;`;
        targetRulerEl.style = `position: absolute; width: 100%; height: 3px; z-index: 9999; background-color: blue; top: ${targetDistance}px;`;
        if (!document.getElementById('ruler-scroll-to') && !document.getElementById('ruler-target')) {
            document.body.appendChild(scrollToRulerEl);
            document.body.appendChild(targetRulerEl);
        }
    };
    __construct();
};
export default ProductPageNav;
